export default __webpack_public_path__ + "static/media/art-brw-banner-3.8f1f1b32.jpg";